import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faPowerOff, faUserCog, faSearch } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Form, Input, Dropdown, Button, ButtonGroup } from "semantic-ui-react";
import moment from "jalali-moment";
import openNewTab from '../../../helpers/openNewTab';

import Modal from '../modal/Modal';
import { showDialog } from "../../../store/actions/dialogActions";
import { removeUserToken } from "../../../store/actions/userActions";
import { getSampleByIdPublic } from "../../../store/actions/sampleActions";

const options = [
  { key: 'results', text: 'مدیریت نتایج', value: { location: 'sample', text: "مدیریت نتایج", type: 0 } },
  { key: 'micResults', text: 'نتایج میکروبی', value: { location: 'sample', text: "نتایج میکروبی", type: 1 } },
  { key: 'chimResults', text: 'نتایج شیمیایی', value: { location: 'sample', text: "نتایج شیمیایی", type: 2 } },
  { key: 'selResults', text: 'نتایج سلولزی', value: { location: 'sample', text: "نتایج سلولزی", type: 3 } },
  { key: 'packResults', text: 'نتایج بسته بندی', value: { location: 'sample', text: "نتایج بسته بندی", type: 4 } },
  { key: 'envResults', text: 'نتایج محیط زیست', value: { location: 'sample', text: "نتایج محیط زیست", type: 5 } },
]

const Header = (props) => {

  const [showModal, setShowModal] = useState(false);
  const [code, setCode] = useState("");
  const [sample, SetSample] = useState({ code: "", name: "", client: "", date: "", id: 0 });

  useEffect(() => {
    if (showModal) {
      setCode("");
      SetSample({ code: "", name: "", client: "", date: "", id: 0 });
    }
  }, [showModal])

  const handleSubmit = async () => {
    console.log("sub!!!!!!!!!!!!!!!!!!!!!!");
    if (!code || isNaN(parseInt(code)) || /[^0-9]/.test(code) || parseInt(code) === 0) {
      props.showDialog({ title: "خطا", text: "کد نمونه صحیح نمی باشد." });
      SetSample({ code: "", name: "", client: "", date: "", id: 0 });
    } else {
      const result = await props.getSampleByIdPublic(parseInt(code));
      if (!result) {
        props.showDialog({ title: "خطا", text: "کد نمونه صحیح نمی باشد." });
        SetSample({ code: "", name: "", client: "", date: "", id: 0 });
      } else {
        const date = moment.from(result.requestDate, "en", "YYYY-MM-DD").locale("fa").format("YYYY/MM/DD");
        SetSample({ code: `S${result.periodKey}-${result.num}`, name: result.sampleName, client: result.clientName, date: date, id: result.sampleId })
        console.log(result);
      }
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  }

  const logout = () => {
    props.removeUserToken();
  }

  const handleInput = (e) => {
    setCode(e.target.value);
  }

  const onDropDownClick = (value) => {
    openNewTab(`/${value.location}`, { id: sample.id, type: value.type });
  }

  return (
    <div className="header">
      <Modal
        open={showModal}
        cancel={() => { setShowModal(false) }}
        title="اسکن نمونه"
        save={() => { handleSubmit() }}
        maxWidth="md"
        saveTitle="جستجو"
        saveIcon="search"
        dropdown={true}
        dropdownTitle="عملیات"
        dropdownDisable={sample.id === 0}
        dropdownOptions={options}
        dropdownOnCLick={onDropDownClick}
      >
        <Form onSubmit={() => { handleSubmit() }} autoComplete="off">
          <div className="field-wrapper field-100">
            <label>کد نمونه:</label>
            <Input placeholder="کد نمونه را وارد نمایید یا بارکد را اسکن کنید" type="text" name="code" value={code} onChange={handleInput} autoFocus onKeyDown={handleKeyDown} />
          </div>
          <div className="clearfix"></div>
          <div className="line-break"></div>

          <div className="field-wrapper field-50 right-50">
            <label>کد شناسایی نمونه:</label>
            <Input placeholder="کد شناسایی نمونه" type="text" name="code" value={sample.code} disabled />
          </div>
          <div className="field-wrapper field-50 left-50">
            <label>نام نمونه:</label>
            <Input
              placeholder="نام نمونه"
              type="text"
              name="name"
              value={sample.name}
              disabled
            />
          </div>

          <div className="clearfix"></div>
          <div className="line-break"></div>

          <div className="field-wrapper field-50 right-50">
            <label>مشتری:</label>
            <Input placeholder="مشتری" type="text" name="client" value={sample.client} disabled />
          </div>
          <div className="field-wrapper field-50 left-50">
            <label>تاریخ:</label>
            <Input
              placeholder="تاریخ"
              type="text"
              name="date"
              value={sample.date}
              disabled
            />
          </div>

          <div className="clearfix"></div>
          <div className="line-break"></div>
        </Form>
      </Modal>
      <div className="info">
        <span className="menu-icon" onClick={() => props.onClick(true)}>
          <FontAwesomeIcon icon={faBars} fixedWidth />
        </span>
      </div>
      <div>
        <span>
          <span className="logout" title="اسکن نمونه" onClick={() => setShowModal(true)}>
            <FontAwesomeIcon icon={faSearch} fixedWidth />
          </span>
        </span>
        <Link to={{ pathname: "/usersetting" }}>
          <span className="user-setting" title="تنظیمات کاربر">
            <FontAwesomeIcon icon={faUserCog} fixedWidth />
          </span>
        </Link>
        <span>
          <span className="logout" title="خروج" onClick={logout}>
            <FontAwesomeIcon icon={faPowerOff} fixedWidth />
          </span>
        </span>
      </div>
    </div>
  );
};

Header.propTypes = {
  onClick: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  userName: state.userReducer.name,
  periodName: state.userReducer.periodName,
});

export default connect(mapStateToProps, { removeUserToken, showDialog, getSampleByIdPublic })(Header);
